<template>
  <v-dialog persistent v-model="returnDialog" width="720px">
    <v-card>
      <v-card-title>
          <span class="headline">
            {{ $t("LakalaPay.Return.title") }}
          </span>
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="returnDialog = false">
              fa-times
            </v-icon>
          </template>
          <span>
              {{ $t("CRUD.backToList", [$t("LakalaPay.title")]) }}
            </span>
        </v-tooltip>
      </v-card-title>

      <v-card-text>
        <v-container>
           <ValidationObserver ref="observer">
          <v-form>
            <v-row>
                <!-- 收款账户(原付款账户 ) -->
                <v-col cols="6">
                  <span >
                    {{ $t("LakalaPay.Return.inExtCode") + $t("Global.colon") }}
                  </span>
                    <span class="green--text">
                  {{ lakalaAccount.out_ext_code }}
                  </span>
                    <span class="red--text">
                  {{ $t("LakalaPay.Return.returnCode") }}
                  </span>
                </v-col>
                <!-- 账户余额 -->
                <v-col cols="6">
                  <span>
                    {{ $t("LakalaPay.Return.balanceAmt") }}{{ $t("Global.colon") }}
                  </span>
                    <span class="red--text">
                   {{ $t("Global.money") }}{{ lakalaAccount.ord_amt| formatMoney }}
                  </span>
                </v-col>
                <!-- 出款账户 -->
                <v-col cols="6">
                  <span >
                    {{ $t("LakalaPay.Return.outExtCode") + $t("Global.colon") }}
                  </span>
                    <span class="green--text">
                  {{ lakalaAccount.in_ext_code }}
                  </span>
                </v-col>
                <!-- 出款公司 -->
                <v-col cols="6">
                  <span >
                    {{ $t("LakalaPay.Return.companyName") + $t("Global.colon") }}
                  </span>
                  <span class="green--text">
                  {{ (lakalaAccount.third_account_info && lakalaAccount.third_account_info.company_name) ? lakalaAccount.third_account_info.company_name + '(' + lakalaAccount.third_account_info.lakala_out_member_no + ')' : '' }}
                  </span>
                </v-col>
                <!-- 退款金额-->
                <v-col cols="6">
                    <span class="d-flex">
                    {{ $t("LakalaPay.Return.returnPay") }}{{ $t("Global.colon") }}
                        <v-text-field
                            v-model="lakalaAccount.ord_amt"
                            single-line
                            dense
                            type="number"
                            min="0"
                            disabled
                            :prefix="$t('Global.money')"
                        >
                        </v-text-field>
                    </span>
                </v-col>
                <!-- 验证码 -->
                <v-col cols="6" v-if="isShowVcCode">
                  <span class="d-flex">
                    {{ $t("LakalaPay.Return.VCode") }}{{ $t("Global.colon") }}
                    <v-text-field
                        v-model="VCode"
                        single-line
                        dense
                        persistent-hint
                        :hint="$t('LakalaAccount.vc_code_hint')"
                    />
                  </span>
                </v-col>
            </v-row>
          </v-form>
           </ValidationObserver>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" outlined @click="returnDialog = false">{{ $t("$vuetify.close") }}</v-btn>
        <v-btn color="accent" @click="submit()">{{ $t("CRUD.confirm") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import i18n from "@/i18n";
import LakalaInterface from "@/api/lakala_interface";
import ThirdAccountInfo from "@/api/third-account-info"
import { ValidationObserver } from "vee-validate";


export default {
    name: "ReturnDialog",

    props: {
        value: Boolean,
        item: Object
    },
    components: {
        ValidationObserver,
    },
    data: () => ({
        returnDialog: false,
        lakalaAccount: {},
        VCode: null,
        returnCode: null,
        isShowVcCode: false,
    }),
    mounted() {

    },
    methods: {
        submit() {
            if (!this.isShowVcCode) {
                this.$refs.observer.validate().then(
                    async function (result) {
                        if (result) {
                            let submitData = {
                                balance_return_pay: this.lakalaAccount.ord_amt,
                                pay_type: 105, // 支付类型：退款：105
                                pay_code: this.lakalaAccount.pay_code
                            }
                            ThirdAccountInfo.addLklReturnBalance(submitData).then((payResponse) => {
                                if (payResponse.data.status.isOK()) {
                                    this.returnCode = payResponse.data.third_pay_records.pay_code
                                    if (payResponse.data.mobile_validation_flg && payResponse.data.mobile_validation_code != '') {
                                        let submitData = {
                                            return_code: this.returnCode,
                                            validation_code: payResponse.data.mobile_validation_code
                                        }
                                        LakalaInterface.balanceReturn(submitData).then(
                                            function (response) {
                                                if (response.data.status.isOK()) {
                                                    this.$snackbar.success(i18n.t("LakalaPay.Return.successMsg"));
                                                    this.returnDialog = false
                                                }
                                            }.bind(this)
                                        )
                                    } else {
                                        ThirdAccountInfo.mobileValidation({third_record_code: this.returnCode, type: 3}).then((response) => {
                                            if (response.data.status.isOK()) {
                                                this.$snackbar.success(i18n.t("LakalaPay.Return.mobileVCode"));
                                                this.isShowVcCode = true
                                            }
                                        })
                                    }
                                }
                            })
                        }
                    }.bind(this)
                )
            }else if (this.VCode != '') {
                let submitData = {
                    return_code: this.returnCode,
                    validation_code: this.VCode
                }
                LakalaInterface.balanceReturn(submitData).then(
                    function (response) {
                        if (response.data.status.isOK()) {
                            this.$snackbar.success(i18n.t("LakalaPay.Return.successMsg"));
                            this.returnDialog = false
                        }
                    }.bind(this)
                )
            }
        },
    },

    watch: {
        value: {
            immediate: false, //初始赋值也调用
            handler() {
                if (!this.value) {
                    this.VCode = null;
                    this.returnCode = null;
                    this.isShowVcCode = false;
                }
                this.returnDialog = this.value;
            },
        },
        item: {
            immediate: false, //初始赋值也调用
            handler() {
                this.lakalaAccount = this.item;
            },
        },
        returnDialog: {
            handler() {
                this.$emit("input", this.returnDialog);
            },
        },
    },
};
</script>